import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/comingSoon.png';
import _imports_1 from '@/assets/images/slice7.png';
const _withScopeId = n => (_pushScopeId("data-v-13e2f7e2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "main-content"
};
const _hoisted_2 = {
  class: "box"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "comingSoonImg",
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_4 = {
  class: "soonText"
};
const _hoisted_5 = {
  class: "right"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "slice",
  src: _imports_1,
  alt: ""
}, null, -1));
import i18n from '@/language/index';
export default {
  __name: 'ComingSoon',
  setup(__props) {
    // import Header from '@/components/Header'
    // import PageFooter from '@/components/PageFooter'

    return (_ctx, _cache) => {
      const _component_router_link = _resolveComponent("router-link");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", null, [_hoisted_3, _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('noFind.imageFrom')), 1)]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('noFind.InProduction')), 1), _withDirectives(_createElementVNode("div", null, "敬请期待", 512), [[_vShow, _unref(i18n).global.locale.value === 'zh']]), _hoisted_6, _createVNode(_component_router_link, {
        to: "/"
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('noFind.goBack')), 1)]),
        _: 1
      })])])]);
    };
  }
};